/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';

import { isValidData, renderSkeleton } from '../../../data/utils';
import { ApiReducer, ApplicationState } from '../../../data/interfaces';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    apiDocsTitle: {
        ...theme.custom.apiOverviewPage.tabs.overview.apiTagsTitleBox
    },
    apiInfoTitleHead: {
        ...theme.custom.apiOverviewPage.tabs.overview.apiTagsTitleText
    },
    chip: {
        margin: theme.spacing(0.5),
        ...theme.custom.apiOverviewPage.tabs.overview.apiTagsChip
    },
}));

interface ApiTagsProps {
    apiReducer: ApiReducer
}

function ApiTags({ apiReducer }: ApiTagsProps) {
    const classes = useStyles();
    const { loading: apiLoading, api } = apiReducer;
    let tagsData: string[] = [];

    if (isValidData(api)) {
        tagsData = api.tags;
    }

    return (
        <div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm container className={classes.apiDocsTitle}>
                    <Grid item xs lg={12}>
                        <Typography className={classes.apiInfoTitleHead}>
                            <FormattedMessage
                                id="api.apiOverview.apiTags.labels.tags"
                                defaultMessage="Tags"
                            />
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12} sm container lg={12}>
                    {
                        apiLoading ?
                            renderSkeleton("rect", "100%", 25)
                            :
                            tagsData.length === 0 ?
                                <i>
                                    <FormattedMessage
                                        id="api.apiOverview.apiTags.messages.noTags"
                                        defaultMessage="No tags available"
                                    />
                                </i>
                                :
                                tagsData.map((tag, key) => {
                                    return (
                                        <li key={key} style={{ listStyle: 'none' }}>
                                            <Chip
                                                label={tag}
                                                className={classes.chip}
                                            />
                                        </li>
                                    );
                                })
                    }
                </Grid>
            </Grid>
        </div>
    );
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        apiReducer: state.apiReducer
    }
}

export default connect(mapStateToProps)(ApiTags);
